import { render, staticRenderFns } from "./timuXz.vue?vue&type=template&id=650082ac&scoped=true"
import script from "./timuXz.vue?vue&type=script&lang=js"
export * from "./timuXz.vue?vue&type=script&lang=js"
import style0 from "./timuXz.vue?vue&type=style&index=0&id=650082ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650082ac",
  null
  
)

export default component.exports